import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../Pages";
import SignUp from "Pages/Auth/Register";

const AuthRouter = () => {
  return (
    <Routes>
      {/* Redirect /auth/login or any non-localized route to default lang */}
      <Route path="/auth/*" element={<Navigate to="/fa/auth/login" replace />} />

      <Route path="/:lang/auth/signup" element={<SignUp />} />

      <Route path="*" element={<Navigate to="/fa/auth/login" replace />} />
    </Routes>
  );
};

export default AuthRouter;
